import { createStore, combineReducers } from 'redux';
import changeBackground from './reducers/background.js';

export default createStore(combineReducers({ changeBackground }));